<template>
  <div
    class="select-none w-full h-8 rounded-b-lg border-t border-grey-100 bg-gray-100 flex flex-row items-center pl-8 text-grey-500 absolute bottom-0 right-0 left-0"
  >
    <div
      v-for="(element, index) in domTree"
      :key="index"
      class="flex flex-row items-center"
      :class="{
        'text-sm': index < domTree.length - 1,
        'text-primary': index === domTree.length - 1
      }"
    >
      <span
        class="cursor-pointer"
        @click="selectComponent(element.id);"
        >{{ element.label }}</span
      >
      <right-arrow
        v-if="index < domTree.length - 1"
        class="h-4 w-4 fill-current mx-4 text-grey-500"
      />
    </div>
  </div>
</template>
<script>
import RightArrow from '@fortawesome/fontawesome-free/svgs/solid/chevron-right.svg';

export default {
  components: { RightArrow },
  props: {
    base: {
      type: String,
      default: 'Body'
    }
  },
  data() {
    return {
      domTree: []
    };
  },
  created() {
    this.$canvas.on('dom-tree-update', tree => {
      if (tree) {
        const domTree = [...tree];
        // domTree.unshift({ label: this.base });
        this.domTree = domTree;
      } else {
        this.domTree = [];
      }
    });
  },
  methods: {
    selectComponent(id) {
      if (!id) return;
      this.$canvas.emit('select-element-request', id);
    }
  }
};
</script>
